<template>
	<app-modal title="Reject Order" @close="$emit('close')">
		<div class="mx-4">
			<app-radio-group name="chooseReason" :options="rejectReasons" v-model="reason.rejectReason.id" />
			<app-text-area
				v-if="reason.rejectReason.id === 0"
				name="Notes"
				container-class="mt-6"
				placeholder="*Notes"
				v-model="reason.notes"
			/>
			<app-button
				v-if="reason.rejectReason.id || reason.notes"
				class="w-full btn btn-primary"
				:loading="loading"
				@click="rejectOrder"
			>
				Reject Order
			</app-button>
		</div>
	</app-modal>
</template>

<script>
	import AppRadioGroup from '@/components/app/AppRadioGroup.vue';
	import AppButton from '@/components/app/AppButton.vue';
	import AppModal from '@/components/app/AppModal.vue';
	import { mapGetters } from 'vuex';
	import OrderService from '@/services/OrderService';
	import { statuses } from '@/constants/mapOrderStatuses';

	export default {
		name: 'RejectOrderModal',
		components: { AppModal, AppButton, AppRadioGroup },
		emits: ['close', 'updateLocalOrder'],
		computed: {
			...mapGetters({
				rejectReasonsGlobal: 'rejectReasonsGlobal',
			}),
		},
		props: {
			orderId: {
				type: Number,
				required: true,
			},
		},
		data: () => ({
			loading: false,
			rejectReasons: [],
			reason: {
				rejectReason: { id: 0 },
				notes: '',
			},
		}),
		methods: {
			rejectOrder() {
				this.loading = true;
				this.$store.dispatch('setLoadingOrderId', this.orderId);
				OrderService.rejectOrder(this.orderId, 'REJECTED', this.reason)
					.then(() => {
						this.$emit('updateLocalOrder', {
							orderId: this.orderId,
							props: {
								status: statuses.rejected,
							},
						});
						this.$notificationService.success('Order rejected successfully');
						this.$emit('close');
					})
					.catch((e) => this.$notificationService.error(e))
					.finally(() => {
						this.loading = false;
					});
			},
		},
		created() {
			if (!this.rejectReasonsGlobal?.length) {
				this.$store
					.dispatch('setBusinessRejectReasons')
					.then((res) => {
						this.rejectReasons = res;
					})
					.catch((e) => this.$notificationService.error(e));
			} else {
				this.rejectReasons = this.rejectReasonsGlobal;
			}
		},
	};
</script>
